(() => {
  if (window.vuuImageViewerInitialized) return;
  window.vuuImageViewerInitialized = true;
  let dialog, image, stage, status, thumbs, zoomButton, items = [], index = 0, detailed = false, opener;
  const selector = '.main-product-information media-gallery .swiper-main .product-media-container--image img.product-media__image';
  const originalUrl = (node) => {
    const url = new URL(node.getAttribute('data_max_resolution') || node.src, location.href);
    ['width', 'height', 'crop'].forEach(key => url.searchParams.delete(key));
    return url.href;
  };
  const fit = () => {
    if (!dialog?.open || !image.naturalWidth || !image.complete) return;
    const scale = Math.min(stage.clientWidth / image.naturalWidth, stage.clientHeight / image.naturalHeight, 1);
    const chosen = detailed ? Math.min(scale * 2, 1) : scale;
    image.style.width = `${image.naturalWidth * chosen}px`;
    image.style.height = `${image.naturalHeight * chosen}px`;
    zoomButton.disabled = scale >= 1;
    zoomButton.textContent = detailed ? 'Ekrana sığdır' : 'Yakınlaştır';
    zoomButton.setAttribute('aria-pressed', String(detailed));
  };
  const show = (next) => {
    index = (next + items.length) % items.length;
    detailed = false;
    dialog.classList.remove('is-detail');
    stage.scrollTo(0, 0);
    image.style.visibility = 'hidden';
    image.alt = items[index].alt;
    status.textContent = `${index + 1} / ${items.length} · Yükleniyor…`;
    stage.setAttribute('aria-busy', 'true');
    image.src = items[index].src;
    [...thumbs.children].forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    thumbs.children[index]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    zoomButton.textContent = 'Yakınlaştır';
  };
  const build = () => {
    dialog = document.createElement('dialog');
    dialog.className = 'vuu-image-dialog';
    dialog.setAttribute('aria-label', 'Ürün görselleri');
    dialog.innerHTML = '<div class="vuu-image-dialog__header"><span aria-live="polite"></span><button type="button" data-action="zoom" aria-pressed="false">Yakınlaştır</button><button type="button" data-action="close" aria-label="Görsel penceresini kapat" autofocus>×</button></div><div class="vuu-image-dialog__stage" aria-busy="true"><img alt="" decoding="async"></div><div class="vuu-image-dialog__footer"><button type="button" data-action="previous" aria-label="Önceki görsel">←</button><div class="vuu-image-dialog__thumbs" aria-label="Görsel seçimi"></div><button type="button" data-action="next" aria-label="Sonraki görsel">→</button></div>';
    document.body.append(dialog);
    image = dialog.querySelector('.vuu-image-dialog__stage img');
    stage = image.parentElement;
    status = dialog.querySelector('[aria-live]');
    thumbs = dialog.querySelector('.vuu-image-dialog__thumbs');
    zoomButton = dialog.querySelector('[data-action="zoom"]');
    image.addEventListener('load', () => {
      fit();
      image.style.visibility = 'visible';
      stage.setAttribute('aria-busy', 'false');
      status.textContent = `${index + 1} / ${items.length}`;
    });
    image.addEventListener('error', () => { status.textContent = 'Görsel yüklenemedi. Başka bir görsel seçebilirsiniz.'; stage.setAttribute('aria-busy', 'false'); });
    dialog.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      const action = button?.dataset.action;
      if (action === 'close') dialog.close();
      if (action === 'next') show(index + 1);
      if (action === 'previous') show(index - 1);
      if (action === 'zoom') { detailed = !detailed; dialog.classList.toggle('is-detail', detailed); fit(); }
      if (button?.dataset.index !== undefined) show(Number(button.dataset.index));
      if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); }
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); event.stopPropagation(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    dialog.addEventListener('close', () => { document.documentElement.classList.remove('vuu-image-viewer-open'); opener?.focus({ preventScroll: true }); });
    new ResizeObserver(fit).observe(stage);
  };
  const open = (node) => {
    opener = node;
    const gallery = node.closest('media-gallery');
    const sources = [...gallery.querySelectorAll('.swiper-main .product-media-container--image')].sort((a, b) => Number(a.dataset.zoomIndex) - Number(b.dataset.zoomIndex));
    const seen = new Set();
    items = sources.map(container => container.querySelector('img.product-media__image')).filter(Boolean).map(img => ({ src: originalUrl(img), alt: img.alt, thumbnail: img.currentSrc || img.src, ratio: Number(img.getAttribute('width')) / Number(img.getAttribute('height')) })).filter(item => { if (seen.has(item.src)) return false; seen.add(item.src); return true; });
    if (!items.length) return;
    if (!dialog) build();
    thumbs.replaceChildren(...items.map((item, i) => {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.index = String(i); button.setAttribute('aria-label', `${i + 1}. görsel`); button.style.setProperty('--ratio', item.ratio || 1);
      const img = document.createElement('img'); img.src = item.thumbnail; img.alt = ''; button.append(img); return button;
    }));
    document.documentElement.classList.add('vuu-image-viewer-open');
    dialog.showModal();
    show(Math.max(0, items.findIndex(item => item.src === originalUrl(node))));
  };
  document.addEventListener('click', (event) => { const node = event.target.closest(selector); if (!node) return; event.preventDefault(); event.stopImmediatePropagation(); open(node); }, true);
  document.addEventListener('keydown', (event) => { if (event.target.matches(selector) && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); event.stopImmediatePropagation(); open(event.target); } }, true);
  const accessible = (root) => root.querySelectorAll?.(selector).forEach(img => { img.tabIndex = 0; img.setAttribute('role', 'button'); img.setAttribute('aria-label', `${img.alt || 'Ürün görseli'} · Büyüt`); });
  accessible(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) accessible(node); }))).observe(document.body, { childList: true, subtree: true });
})();
